(function () {
  var observer = null;
  var timer = null;

  function cleanText(text) {
    var value = String(text || '');
    value = value.replace(/’/g, "'");
    value = value.split(String.fromCharCode(10)).join(' ');
    value = value.split(String.fromCharCode(13)).join(' ');
    value = value.split(String.fromCharCode(9)).join(' ');
    while (value.indexOf('  ') !== -1) value = value.replace('  ', ' ');
    return value.trim().toLowerCase();
  }

  function isProductPage() {
    return document.body && (document.body.className.indexOf('template-product') !== -1 || window.location.pathname.indexOf('/products/') !== -1);
  }

  function findPolicyBlock() {
    return document.querySelector('.new-policy-container');
  }

  function findBoxFold() {
    var folds = document.querySelectorAll('yg-folded-text');
    for (var i = 0; i < folds.length; i += 1) {
      var title = folds[i].querySelector('.folded-title') || folds[i];
      if (cleanText(title.textContent).indexOf("what's in the box") !== -1) return folds[i];
    }
    return null;
  }

  function keyForBox(box) {
    var text = cleanText(box && box.textContent);
    var img = box && box.querySelector('img');
    return text || (img && (img.alt || img.src)) || '';
  }

  function tryUnslick(frame) {
    if (!frame || !window.jQuery) return;
    try {
      var $frame = window.jQuery(frame);
      if ($frame.hasClass('slick-initialized') && typeof $frame.slick === 'function') {
        $frame.slick('unslick');
      }
    } catch (error) {}
  }

  function removeClassName(el, name) {
    if (!el || !el.className) return;
    var parts = String(el.className).split(' ');
    var kept = [];
    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i] && parts[i] !== name) kept.push(parts[i]);
    }
    el.className = kept.join(' ');
  }

  function normalizeFrame(block) {
    var frame = block && block.querySelector('.new-store-policy-frame');
    if (!frame) return false;

    tryUnslick(frame);

    var rawBoxes = frame.querySelectorAll('.new-store-policy-box');
    if (!rawBoxes.length) return false;

    var ordered = [];
    for (var i = 0; i < rawBoxes.length; i += 1) ordered.push(rawBoxes[i]);
    ordered.sort(function (a, b) {
      var ac = String(a.className).indexOf('slick-cloned') !== -1 ? 1 : 0;
      var bc = String(b.className).indexOf('slick-cloned') !== -1 ? 1 : 0;
      return ac - bc;
    });

    var seen = {};
    var boxes = [];
    for (var j = 0; j < ordered.length; j += 1) {
      var key = keyForBox(ordered[j]);
      if (!key || seen[key]) continue;
      seen[key] = true;
      boxes.push(ordered[j]);
    }
    if (!boxes.length) return false;

    removeClassName(frame, 'slick-initialized');
    removeClassName(frame, 'slick-slider');
    removeClassName(frame, 'slick-dotted');
    frame.removeAttribute('style');
    while (frame.firstChild) frame.removeChild(frame.firstChild);

    for (var k = 0; k < boxes.length; k += 1) {
      var box = boxes[k];
      removeClassName(box, 'slick-slide');
      removeClassName(box, 'slick-current');
      removeClassName(box, 'slick-active');
      removeClassName(box, 'slick-cloned');
      box.removeAttribute('style');
      box.removeAttribute('aria-hidden');
      box.removeAttribute('tabindex');
      box.removeAttribute('role');
      frame.appendChild(box);
    }
    return true;
  }

  function movePolicy() {
    if (!isProductPage()) return false;
    var block = findPolicyBlock();
    var fold = findBoxFold();
    if (!block || !fold || !fold.parentNode) return false;

    if (String(block.className).indexOf('dyu-policy-under-box') === -1) {
      block.className += ' dyu-policy-under-box';
    }
    block.setAttribute('data-dyu-policy-location', 'after-whats-in-box');
    if (block.previousElementSibling !== fold) {
      fold.parentNode.insertBefore(block, fold.nextSibling);
    }
    normalizeFrame(block);
    return true;
  }

  function scheduleMove(delay) {
    window.setTimeout(movePolicy, delay);
  }

  function startRetries() {
    var delays = [0, 80, 180, 350, 700, 1100, 1700, 2600, 3800, 5600, 8000, 11000];
    for (var i = 0; i < delays.length; i += 1) scheduleMove(delays[i]);
  }

  function startObserver() {
    if (!window.MutationObserver || observer || !document.body) return;
    observer = new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(movePolicy, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  function init() {
    if (!isProductPage()) return;
    startRetries();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
